var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors.length)?_c('p',[_c('b',{staticClass:"text-danger"},[_vm._v("Please correct the following error(s):")]),_c('ul',_vm._l((_vm.errors),function(error){return _c('li',{key:error},[_vm._v(_vm._s(error))])}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }